import { render, staticRenderFns } from "./NewHeader.vue?vue&type=template&id=00982d4a&scoped=true"
import script from "./NewHeader.js?vue&type=script&lang=js&external"
export * from "./NewHeader.js?vue&type=script&lang=js&external"
import style0 from "./NewHeader.scss?vue&type=style&index=0&id=00982d4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00982d4a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
